import moment from 'moment';
import CoachingContentDetailScore from 'records/CoachingContentDetailScore';
import {Record, List, Map} from 'immutable';
import {ContentDetailId} from 'records/CoachingContentDetail';

export type CoachingReviewFileuploadId = number;
export type FileUploadId = string; // TODO move when its ts-ified
export type ScorecardResultId = number; // TODO move when its ts-ified

export default class CoachingReviewFileUpload extends Record({
  id: null,
  addedByUserId: List(),
  addedOn: null,
  score: null,
  fileuploadId: null,
  scorecardResultId: null,
  contentDetailIds: null,
  reviewFeedbackList: null,
  highLevelScores: null,
  livecoaching: false,
  comment: null,
  callRecordingLink: null,
}) {
  readonly id?: CoachingReviewFileuploadId;
  readonly addedByUserId?: List<string>;
  readonly addedOn?: moment.Moment;
  readonly score?: number; // Int
  readonly fileuploadId?: FileUploadId;
  readonly scorecardResultId?: ScorecardResultId;
  readonly contentDetailIds?: List<ContentDetailId>;
  readonly reviewFeedbackList?: List<CoachingContentDetailScore>; // TODO
  readonly highLevelScores?: Map<ContentDetailId, number>; // TODO doublecheck this typing
  readonly livecoaching?: boolean;
  readonly comment?: string;
  readonly callRecordingLink?: URL;

  constructor(object: Partial<CoachingReviewFileUpload> = {}) {
    super({
      ...object,
      contentDetailIds: object.contentDetailIds ? List(object.contentDetailIds) : List(),
      addedOn: moment(object.addedOn),
      reviewFeedbackList: List(
        (object.reviewFeedbackList || []).map(
          contentDetailScore => new CoachingContentDetailScore(contentDetailScore)
        )
      ),
    });
  }
}
